<p>
  Welcome to the Admin dashboard!
</p>

The Authentication Guard in the Core Module will only allow you access this route if you have logged in.


<h2>{{ 'HEADER.TITLE' | translate }}dfdfd</h2>